import React, { FC } from 'react'

import { IconTheftProps } from './IconTheft.types'
import * as Styled from './styles/IconTheft.style'

import { nonThemeableRules } from '../../ruleSet'

const IconTheft: FC<IconTheftProps> = ({
  size = nonThemeableRules.defaultSize as number as IconTheftProps['size'],
  isResponsive = false,
}: IconTheftProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='m23.953 24.344-4.527-5.418m.199 5.707L16.75 21.16m14.211 2.258a1.889 1.889 0 0 0-.313-1.984s-5.328-6.25-5.851-7c-1.617-2.281-1.84-3.094-1.688-3.524.29-.832 3 0 4.602-.05 2.816-.114 3.117-2.25 2.727-2.477-1.305-.774-3.707-.856-11.93-3-4.543-1.18-6.523.93-7.5 1.75-1.852 1.547-2.75 3.289-2.676 6.043.121 3.8 5.68 10.25 5.68 10.25l1.379 1.652m6.757-8.378 5.825 6.972m13.871 14.18v.03c.054.165.097.333.133.5.046.247.07.497.07.75a3.831 3.831 0 0 1-3.832 3.833H9.773a3.831 3.831 0 0 1-3.832-3.832c0-.254.024-.504.07-.75a4.61 4.61 0 0 1 .134-.5l.011-.031L8.72 30.5l-2.383-4.426 2.535-.222'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='m8.871 25.852 27.844-2.461 5.129 14.46' stroke='#fff' strokeLinecap='round' strokeWidth='2' />
        <path
          d='M17.719 30.5v2.043a6.289 6.289 0 0 0 12.574 0v-2.027'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M18.848 30.55a1.127 1.127 0 1 1-2.254.005 1.127 1.127 0 0 1 2.254-.004Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M18.086 30.55a.366.366 0 1 1-.367-.363c.203 0 .367.165.367.364Zm13.332 0a1.127 1.127 0 1 1-2.254.005 1.127 1.127 0 0 1 2.254-.004Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M30.656 30.55a.366.366 0 1 1-.367-.363c.203 0 .367.165.367.364Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconTheft
